/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

import React from 'react';
import { FormGroup, FormControl } from 'react-bootstrap';
import SelectCountry from './SelectCountry';

const MobileInput = (props) => {
    const {
        i18n,
        onChangeAction,
        handleTextChange,
        maxLength,
        isPhnFilled,
        selectRef,
        phnRef,
        isDisplayErr,
        inputErrMsg
    } = props;
    let hideErrMsg = isDisplayErr ? "" : "hidden";
    return (
        <div className="logon-phn-group">
            <div data-key={"logon_phnNumber_txt"}>{i18n.phnNumber}</div>
            <SelectCountry 
                ref={selectRef}
                changeValEvt={onChangeAction}
                content={i18n}/>
            <div className={"logon-phn-body"}>
                <div className="logon-mobile-title-fsize">
                    <label htmlFor="numberTitle" data-key="logon_numberLabel">{i18n.number}</label>
                </div>
                <FormGroup validationState={isPhnFilled && !isDisplayErr ? "success" : null}>
                    <FormControl
                        role="textbox"
                        id="numberTitle"
                        aria-invalid={isDisplayErr}
                        aria-required={true}
                        type="tel"
                        bsClass={"logon-phn-input " + (isDisplayErr ? "logon-phn-error" : "")}
                        inputRef={phnRef}
                        maxLength={maxLength}
                        onInput={handleTextChange} 
                        data-key={"logon_mobile_input"}/>
                    {
                        isPhnFilled && !isDisplayErr &&
                        <span className="screen-reader-only" aria-live="polite"> Input accepted</span>
                    }
                    <FormControl.Feedback className={"icon icon-circle-confirmation-solid logon-confirmIcon"} />
                </FormGroup>
            </div>
            <div className="logon-mobile-info">
                <div className={"logon-input-info icon-logon icon icon-circle-delete logon-input-err " + hideErrMsg}>
                    <span aria-hidden={isDisplayErr} data-key={"logon_errPhnMsg"}>{inputErrMsg}</span>
                </div>
                <div className="logon-input-info icon-logon icon icon-circle-info">
                    <span title={i18n.phn_info} data-key={"logon_phn_info"}>{i18n.phn_info}</span>
                </div>
            </div>  
        </div>
    )
};


MobileInput.defaultProps = {

};

export default MobileInput;


// WEBPACK FOOTER //
// ./src/views/Logon/components/MobileInput.js